import React from "react";
import ForbiddenTable from "../../components/403/ForbiddenTable";

export default function ForbiddenPage() {
  return <ForbiddenTable />;
}
